import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,
  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'feed',
    layout: '1',
  },
  itemDesign: {},
  containerDesign: {},
};

export const singleProductSlice = createSlice({
  name: 'singleProduct',
  initialState,
  reducers: {
    singleProductStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;
      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading?.title ?? '',
          description: blockContent.heading?.description ?? '',
          textAlign: blockContent.heading?.textAlign ?? 'left',
          image: blockContent.heading?.image ?? '',
          divider: blockContent.heading?.divider ?? '',
          position: blockContent.heading?.position ?? '',
        },
      };

      state.blockDesign = {
        view: blockDesign.view ?? 'feed',
        layout: blockDesign.layout ?? '1',
      };
    },
    singleProductClear: () => initialState,
    singleProductUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    singleProductUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    singleProductUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    singleProductUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { singleProductStore, singleProductClear, singleProductUpdateIsLoading, singleProductUpdateIsActive, singleProductUpdateBlockContent, singleProductUpdateBlockDesign } = singleProductSlice.actions;

export const selectSingleProductIsLoading = (state) => state.singleProduct.isLoading;
export const selectSingleProductId = (state) => state.singleProduct.id;
export const selectSingleProductUID = (state) => state.singleProduct.uid;
export const selectSingleProductSID = (state) => state.singleProduct.sid;
export const selectSingleProductBlockContent = (state) => state.singleProduct.blockContent;
export const selectSingleProductBlockDesign = (state) => state.singleProduct.blockDesign;
export const selectSingleProductItemDesign = (state) => state.singleProduct.itemDesign;
export const selectSingleProductContainerDesign = (state) => state.singleProduct.containerDesign;

export default singleProductSlice.reducer;
